import {$WS} from "../webSocketProtoHead";
import {MSG} from "../../proto/proto";
import {SUB} from "../wsProtoConfigBase";

/**
 * 请求获取主机ID
 */
export default class CSubGetHostUid implements $WS.WebSocketProtoHeadBody {
    //协议头
    static readonly HEAD: number = SUB.CSubGetHostUid;
    //
    readonly head: number;

    constructor() {
        this.head = CSubGetHostUid.HEAD;
    }

    getPackageBody(gameId:number): Uint8Array {
        let obj = $WS.getHallGameProtoHeadObject(this.head, $WS.ProtoHead.GAME, gameId);
        return MSG.CSubLoginServer.encode(obj).finish();
    }

    static unPackageMessage(message: Uint8Array): CSubGetHostUid {
        return new CSubGetHostUid();
    }
}